module.exports = __webpack_public_path__ + "img/201805-4.8c1f7785.jpeg";